<ng-container *ngIf="this.displayLabelToolTip === true; else nonAdminDdcLabel">
  <span  [innerHTML]="label" matTooltip="{{labelKey}}" matTooltipPosition="above"></span>
</ng-container>
<ng-template #nonAdminDdcLabel>
  <span  [innerHTML]="label"></span>
</ng-template>
